import { render } from "./LayoutFooterNew2.vue?vue&type=template&id=309cc468&scoped=true"
import script from "./LayoutFooterNew2.vue?vue&type=script&lang=js"
export * from "./LayoutFooterNew2.vue?vue&type=script&lang=js"

import "./LayoutFooterNew2.vue?vue&type=style&index=0&id=309cc468&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-309cc468"]])

export default __exports__